import React, { useRef, useState } from 'react';

import './style.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faImage, faLink } from '@fortawesome/pro-solid-svg-icons';
import Modal from '../Modal';
export interface PrepAreaVideo {
    locale: string;
    title: string;
    link: string;
}
export interface Attachment {
    fileName: string;
    locale: string;
    publicUrl: string;
    size: number;
    file: {
        name: string;
        size: number;
    };
}

const getYoutubeID = (link: string) => {
    const regex = new RegExp(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|shorts\/|watch\?v=))([\w-]{11})/);

    const [, id = ''] = regex.exec(link) || ['', ''];
    if (id) {
        return id;
    }
    return '';
};

const displayIconByType = (name: string) => {
    const type = name.split('.').pop();
    if (type === 'jpeg' || type === 'png') {
        return <FontAwesomeIcon icon={faImage} />;
    }
    if (type === 'pdf') {
        return <FontAwesomeIcon icon={faFilePdf} />;
    }
    return <FontAwesomeIcon icon={faLink} />;
};
const PrepAreaAttachments: React.FC<{
    videos: PrepAreaVideo[] | [];
    attachments: Attachment[] | [];
    selectedLanguage?: string;
}> = ({ videos = [], attachments = [], selectedLanguage }) => {
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const iframeRef = useRef(null);

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const renderAttachments = () => {
        if (!attachments || !attachments?.length) {
            return null;
        }
        // eslint-disable-next-line no-restricted-globals
        const [protocol, host] = [location.protocol, location.host];
        let baseUrl = '';
        if (host.includes('request-availability.')) {
            baseUrl = `${protocol}//${host.replace('request-availability.', '')}`;
        }
        if (host.includes('portal.')) {
            if (host.includes('portal.stage')) {
                baseUrl = `${protocol}//${host.replace('portal.', '')}`;
            } else {
                baseUrl = `${protocol}//${host.replace('portal.', 'a.')}`;
            }
        }
        return (
            <>
                {attachments
                    .filter(({ locale }) => locale === selectedLanguage)
                    .map((attachment) => {
                        const [nameWithoutExtension = ''] = (attachment.file?.name || attachment.fileName).split('.');
                        return (
                            <div className="attachmentCard">
                                <a href={`${baseUrl}${attachment.publicUrl}`} target="_blank" rel="noreferrer">
                                    <div className="attachmentICon">
                                        {displayIconByType(attachment.file?.name || attachment.fileName)}
                                    </div>
                                </a>
                                <span className="attachmentCardTitle">{nameWithoutExtension}</span>
                            </div>
                        );
                    })}
            </>
        );
    };

    const renderYoutubeVids = () => {
        const useDefaultLenguague = videos.filter(({ locale }) => locale === selectedLanguage).length
            ? selectedLanguage
            : 'en';
        return videos
            .filter(({ locale }) => locale === useDefaultLenguague)
            .map(({ title, link }) => (
                <div className="youtubeCard">
                    <div style={{ width: '250px', height: '160px', cursor: 'pointer' }} onClick={showModal}>
                        <img
                            width="100%"
                            height="100%"
                            alt="test"
                            src={`https://img.youtube.com/vi/${getYoutubeID(link)}/default.jpg`}
                        />
                    </div>
                    <span className="youtubeCardTitle">{title}</span>
                    <Modal isOpen={isModalOpen} onClose={handleCancel} iframeRef={iframeRef}>
                        <iframe
                            ref={iframeRef}
                            width={'100%'}
                            height={'100%'}
                            src={`https://www.youtube.com/embed/${getYoutubeID(link)}`}
                            title={title}
                            frameBorder="0"
                            allow="accelerometer; encrypted-media; gyroscope; picture-in-picture;"
                            allowFullScreen
                        />
                    </Modal>
                </div>
            ));
    };
    return (
        <div className="youtubeContainerCard">
            {renderYoutubeVids()}
            {renderAttachments()}
        </div>
    );
};

export default PrepAreaAttachments;
